var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMastercardLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 37,
    viewBox: "0 0 58 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_522_5580)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.8424 32.5824H21.1582V4.41518H36.8424V32.5824Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1536 18.5C22.1512 15.7875 22.7664 13.11 23.9525 10.6702C25.1387 8.23036 26.8647 6.09221 29 4.41759C26.3558 2.34091 23.1803 1.04952 19.8365 0.690997C16.4927 0.332479 13.1154 0.921294 10.0905 2.39015C7.0657 3.85901 4.51538 6.14866 2.73103 8.99743C0.946686 11.8462 0.000289205 15.1392 0 18.5C0.000645359 21.8604 0.947154 25.1529 2.73138 28.0012C4.51561 30.8496 7.0656 33.1389 10.09 34.6077C13.1144 36.0765 16.4912 36.6654 19.8347 36.3073C23.1781 35.9492 26.3534 34.6584 28.9976 32.5824C26.863 30.9073 25.1376 28.769 23.9519 26.3293C22.7662 23.8895 22.1513 21.2123 22.1536 18.5Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 18.5C57.9997 21.8608 57.0533 25.1538 55.269 28.0026C53.4846 30.8513 50.9343 33.141 47.9095 34.6098C44.8846 36.0787 41.5073 36.6675 38.1635 36.309C34.8197 35.9505 31.6442 34.6591 29 32.5824C33.1688 29.3027 35.8464 24.2141 35.8464 18.5C35.8464 12.7859 33.1688 7.69728 29 4.41759C31.6442 2.34091 34.8197 1.04952 38.1635 0.690997C41.5073 0.332479 44.8846 0.921294 47.9095 2.39015C50.9343 3.85901 53.4846 6.14866 55.269 8.99743C57.0533 11.8462 57.9997 15.1392 58 18.5Z",
    fill: "#F79E1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_522_5580"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 36,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercardLogo);
export default __webpack_public_path__ + "static/media/mastercard-logo.b36be285f4d7aa3e359ed9ad5570738e.svg";
export { ForwardRef as ReactComponent };